
import { FETCH_DERNIER_DOCS_REQUEST, FETCH_DERNIER_DOCS_SUCCESS, FETCH_DERNIER_DOCS_FAILURE } from './actionsTypes';

export const fetchDerniersDocsRequest = (token,history) => ({
  type: FETCH_DERNIER_DOCS_REQUEST,
  payload: { token,history },
});

export const fetchDerniersDocsSuccess = (derniersDocsData) => ({
  type: FETCH_DERNIER_DOCS_SUCCESS,
  payload: { derniersDocsData },
});

export const fetchDerniersDocsFailure = (error) => ({
  type: FETCH_DERNIER_DOCS_FAILURE,
  payload: { error },
});

